module.exports = __webpack_public_path__ + "static/media/druid_boots.9546fc82.png";